import React from "react";
import PropTypes from  "prop-types";
import ReactInterval from "react-interval";
import "moment/locale/ru";
import moment from "moment";
import Moment from "react-moment";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// import material-ui icons
import RefreshIcon from "@material-ui/icons/Refresh";
import DeleteIcon from "@material-ui/icons/Delete";
import ChartIcon from "@material-ui/icons/ShowChart";
import EditIcon from "@material-ui/icons/Edit";
import LogIcon from "@material-ui/icons/Subject";
// import material-ui components
import Grid from "@material-ui/core/Grid";
import { withStyles }  from "@material-ui/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as actionCreators from "actions/machines";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Table from "components/Table/Table.jsx";
import CustomInput from "components/CustomInput/CustomInput";
import PhoneNumber from "components/NumberPrettifier/NumberPrettifier";
import ConfirmDeleteDialog from "components/Dialogs/ConfirmDeleteDialog";
import EditMachineLimitDialog from "components/Dialogs/EditMachineLimitsDialog";
import SuccessDialog from "components/Dialogs/SuccessDialog";
import ErrorDialog from "components/Dialogs/ErrorDialog";
import LogsDialog from "components/Dialogs/LogsDialog";

import machineStyle from "assets/jss/material-dashboard-react/views/machineStyle";

import { getErrorFromCode } from "../../utils/misc";

import { getMonthFromNum } from "../../utils/misc";
import { getDailySalesChart } from "../../utils/charts";
import { months, years } from "../../variables/general";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        machineIsLoaded: state.machines.machine.isLoaded,
        machineIsLoading: state.machines.machine.isLoading,
        machine: state.machines.machine.data,
        machineDailySales: state.machines.machineDailySales,
        machineLogs: state.machines.machineLogs,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class MachineView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            machineData: null,
            machineId: this.props.match.params.id ? this.props.match.params.id : null,
            timeoutEnabled: false,
            machineSettings: {
                address: "",
                liter_for_cash: "",
                liter_for_key: "",
                impulse_per_liter: "",
                admin_key_hash: "",
                admin_phone_number: "",
                sim_module_number: "",
                additional_params: "",
            },
            deleteMachineDialogIsOpened: false,
            machineDailySalesChartData: null,
            machineDailySalesYear: new Date().getFullYear(),
            machineDailySalesMonth: new Date().getMonth() + 1,
            machineDailySalesType: "money",
            machineEditLimitsDialogIsOpened: false,
            successDialogIsOpened: false,
            errorDialogIsOpened: false,
            logsDialogIsOpened: false,
            logsLimit: 200,
            logsFromTime: moment(new Date().setHours(0,0,0,0)),
            logsToTime: moment(new Date()),
        }
    }

    componentWillReceiveProps(nextProps, nextContext){
        this.setState(prevState => ({
            machineId: nextProps.match.params.id ? nextProps.match.params.id : null,
            machineData: nextProps.machine ? nextProps.machine : this.state.machineData,
            machineSettings: !prevState.machineSettings.liter_for_cash && !nextProps.machineIsLoading && nextProps.machine ? {
                address: nextProps.machine.address,
                liter_for_cash: nextProps.machine.liter_for_cash,
                liter_for_key: nextProps.machine.liter_for_key,
                impulse_per_liter: nextProps.machine.impulse_per_liter,
                admin_key_hash: nextProps.machine.admin_key_hash,
                admin_phone_number: nextProps.machine.admin_phone_number,
                sim_module_number: nextProps.machine.sim_module_number,
                additional_params: JSON.stringify(nextProps.machine.additional_params),
            } : prevState.machineSettings,

        }));
        nextProps.machineDailySales.isLoaded && JSON.stringify(this.state.machineDailySalesChartData) !==  JSON.stringify(getDailySalesChart(nextProps.machineDailySales.data, "Дневные продажи")) &&
            this.setState({
                machineDailySalesChartData: getDailySalesChart(nextProps.machineDailySales.data, "Дневные продажи")
            })
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true,
        });
        this.getData();
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
            machineData: null,
            machineSettings: {
                address: "",
                liter_for_cash: "",
                liter_for_key: "",
                impulse_per_liter: "",
                admin_key_hash: "",
                admin_phone_number: "",
                sim_module_number: "",
                additional_params: "",
            },
        })
    }

    getData(){
        this.state.machineId && this.props.getMachine(this.props.token, this.state.machineId);
        this.state.machineId && this.props.getMachineDailySales(this.props.token, this.state.machineId,
            this.state.machineDailySalesYear, this.state.machineDailySalesMonth, this.state.machineDailySalesType);
        this.state.machineId && this.props.getMachineLogs(this.props.token, this.state.machineId,
            ~~(this.state.logsFromTime.valueOf()/1000), ~~(this.state.logsToTime.valueOf()/1000), this.state.logsLimit);
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState((prev_state) => ({
            ...prev_state,
            machineSettings: {
                ...prev_state.machineSettings,
                ...next_state,
            }
        }))
    }

    saveMachine(){
        this.props.editMachine(this.props.token, {
            ...this.state.machineSettings,
            id: this.state.machineData.id,
            additional_params: JSON.parse(this.state.machineSettings.additional_params),
        }).then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()})
    }

    updateTime(param){
        this.props.editMachine(this.props.token, {
            [param]: new Date().toISOString(),
            id: this.state.machineData.id,
        })
    }

    deleteMachineDialogOpen(){
        this.setState({
            deleteMachineDialogIsOpened: true,
        })
    }

    deleteMachineDialogClose(){
        this.setState({
            deleteMachineDialogIsOpened: false,
        })
    }

    deleteMachine(){
        this.deleteMachineDialogClose();
        this.state.machineData && this.props.deleteMachine(this.props.token, this.state.machineData.id);
    }

    editMachineLimitsDialogOpen(){
        this.setState({
            editMachineLimitsDialogIsOpened: true
        })
    }

    editMachineLimitsDialogClose(){
        this.setState({
            editMachineLimitsDialogIsOpened: false
        })
    }

    editMachineLimits(data){
        this.editMachineLimitsDialogClose();
        this.props.editMachine(this.props.token, {
            ...data,
            id: this.state.machineId
        })
    }

    handleChangeState(type, data){
        this.setState({
            [type]: data
        }, this.getData)
    }

    successDialogShow(){
        this.setState({
            successDialogIsOpened: true,
        })
    }

    successDialogClose(){
        this.setState({
            successDialogIsOpened: false,
        })
    }

    errorDialogOpen(){
        this.setState({
            errorDialogIsOpened: true,
        })
    }

    errorDialogClose(){
        this.setState({
            errorDialogIsOpened: false,
        })
    }

    logsDialogOpen(){
        this.setState({
            logsDialogIsOpened: true,
        })
    }

    logsDialogClose(){
        this.setState({
            logsDialogIsOpened: false,
        })
    }

    render(){
        const { classes } = this.props;
        return this.props.machineIsLoaded && this.state.machineData ? (
            <Grid container>
                <GridItem xs={12}>
                    <div className={classes.flex_sp_btw}>
                        <h3>Автомат #{this.state.machineData.id}</h3>
                        <div className={classes.btnContainer}>
                            <Button color="success" size="sm" onClick={() => this.logsDialogOpen()}>
                                <LogIcon/>Логи
                            </Button>
                            <Button color="danger" size="sm" onClick={()=>this.deleteMachineDialogOpen()}>
                                <DeleteIcon/>Удалить
                            </Button>
                        </div>
                    </div>
                </GridItem>
                { this.props.machineDailySales.isLoaded && !!this.state.machineDailySalesChartData && <GridItem xs={12}>
                    <Card>
                        <CardHeader color="success" icon>
                            <CardIcon color="success">
                                <ChartIcon/>
                            </CardIcon>
                            <p className={classes.cardCategory}/>
                            <h3 className={classes.cardTitle}>{`Продажи за ${getMonthFromNum(this.state.machineDailySalesMonth)}, ${this.state.machineDailySalesYear}`}</h3>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="machine_daily_sales_month">Выбрать месяц:</InputLabel>
                                <Select
                                    value={this.state.machineDailySalesMonth}
                                    onChange={(e) => this.handleChangeState("machineDailySalesMonth", e.target.value)}
                                    inputProps={{
                                        name: 'machine_daily_sales_month',
                                        id: 'machine_daily_sales_month',
                                    }}
                                    className={classes.select}

                                >
                                    {months.map((month, key) => (
                                        <MenuItem value={key+1} key={key}>{month}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="machine_daily_sales_year">Выбрать год:</InputLabel>
                                <Select
                                    value={this.state.machineDailySalesYear}
                                    onChange={(e) => this.handleChangeState("machineDailySalesYear", e.target.value)}
                                    inputProps={{
                                        name: 'machine_daily_sales_year',
                                        id: 'machine_daily_sales_year',
                                    }}
                                    className={classes.select}

                                >
                                    {years.map((year, key) => (
                                        <MenuItem value={year} key={key}>{year}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel htmlFor="machine_daily_sales_type">Выбрать тип:</InputLabel>
                                <Select
                                    value={this.state.machineDailySalesType}
                                    onChange={(e) => this.handleChangeState("machineDailySalesType", e.target.value)}
                                    inputProps={{
                                        name: 'machine_daily_sales_type',
                                        id: 'machine_daily_sales_type',
                                    }}
                                    className={classes.select}

                                >
                                    <MenuItem value={"money"} >Рубли</MenuItem>
                                    <MenuItem value={"liters"} >Литры</MenuItem>
                                </Select>
                            </FormControl>
                        </CardHeader>
                        <CardBody>
                            <ChartistGraph
                                data={this.state.machineDailySalesChartData.data}
                                type="Line"
                                options={this.state.machineDailySalesChartData.options}
                                listener={this.state.machineDailySalesChartData.animation}
                                className={classes.chartContainer}
                            />
                        </CardBody>
                    </Card>
                </GridItem>}
                <GridItem xs={12} s={6} md={6}>
                    <Card>
                        <CardHeader color="primary">
                            <h5>Общее</h5>
                        </CardHeader>
                        <CardBody>
                            <Table tableData={[["Адрес", this.state.machineData.address ? this.state.machineData.address : "Н/Д"],
                                               ["Версия ПО", this.state.machineData.software_ver ? this.state.machineData.software_ver : "Н/Д"],
                                               ["Ключ админа", this.state.machineData.admin_key_hash ? this.state.machineData.admin_key_hash : "Н/Д"],
                                               ["Телефон админа", this.state.machineData.admin_phone_number ? <PhoneNumber number={this.state.machineData.admin_phone_number} /> : "Н/Д"],
                                               ["Телефон SIM-модуля", this.state.machineData.sim_module_number ? <PhoneNumber number={this.state.machineData.sim_module_number} /> : "Н/Д"],
                                               ["Кол-во монет", this.state.machineData.coins_count || this.state.machineData.coins_count === 0 ? this.state.machineData.coins_count : "Н/Д"],
                                               ["Кол-во купюр", this.state.machineData.bills_count || this.state.machineData.bills_count === 0 ? this.state.machineData.bills_count : "Н/Д"],
                                               ["Непотраченный остаток", this.state.machineData.unspent_cash || this.state.machineData.unspent_cash === 0 ? this.state.machineData.unspent_cash: "Н/Д"],
                                               ["Организация", this.state.machineData.organization],
                                               ["Дата запуска", <Moment format="DD/MM/YYYY" locale="ru">{this.state.machineData.launch_date}</Moment>]
                            ]}/>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader color="success">
                            <h5>Обслуживание</h5>
                        </CardHeader>
                        <CardBody>
                            <Table  tableData={[["Ошибка", getErrorFromCode(this.state.machineData.error), ""],
                                                ["Время работы УФ лампы", <div><Moment toNow ago locale="ru">{this.state.machineData.uv_lamp_last_change}</Moment>
                                                    &nbsp;/&nbsp;<Moment interval={0} fromNow subtract={{seconds: this.state.machineData.uv_lamp_max_seconds}} ago locale="ru"/></div>,
                                                    <div><Button justIcon round simple onClick={() => this.updateTime("uv_lamp_last_change")} color="transparent"><RefreshIcon/></Button>
                                                        <Button justIcon round simple onClick={() => this.editMachineLimitsDialogOpen()} color="transparent"><EditIcon/></Button></div>],
                                                ["Время работы озонатора", <div><Moment interval={0} fromNow subtract={{seconds: this.state.machineData.time_ozone}} ago locale="ru"/>
                                                    &nbsp;/&nbsp;<Moment interval={0} fromNow subtract={{seconds: this.state.machineData.ozone_max_seconds}} ago locale="ru"/></div>,
                                                    <div><Button justIcon round simple onClick={() => this.updateTime("ozone_last_change")} color="transparent"><RefreshIcon/></Button>
                                                        <Button justIcon round simple onClick={() => this.editMachineLimitsDialogOpen()} color="transparent"><EditIcon/></Button></div>],
                                                ["Время работы насоса", <div><Moment interval={0} fromNow subtract={{seconds: this.state.machineData.time_pump}} ago locale="ru"/>
                                                    &nbsp;/&nbsp;<Moment interval={0} fromNow subtract={{seconds: this.state.machineData.pump_max_seconds}} ago locale="ru"/></div>,
                                                    <div><Button justIcon round simple onClick={() => this.updateTime("pump_last_change")} color="transparent"><RefreshIcon/></Button>
                                                        <Button justIcon round simple onClick={() => this.editMachineLimitsDialogOpen()} color="transparent"><EditIcon/></Button></div>],
                                                ["Литры через фильтр", this.state.machineData.liters_filter ? `${this.state.machineData.liters_filter} л / ${this.state.machineData.filter_max_liters} л` : "Н/Д",
                                                    <div><Button justIcon round simple onClick={() => this.updateTime("filter_last_change")} color="transparent"><RefreshIcon/></Button>
                                                        <Button justIcon round simple onClick={() => this.editMachineLimitsDialogOpen()} color="transparent"><EditIcon/></Button></div>],
                                                ["Промывка аппарата", <Moment format="DD/MM/YYYY" locale="ru">{this.state.machineData.last_flushing}</Moment>,
                                                    <Button justIcon round simple onClick={() => this.updateTime("last_flushing")} color="transparent"><RefreshIcon/></Button>],
                                                ["Промывка трубопровода", <Moment format="DD/MM/YYYY" locale="ru">{this.state.machineData.last_flushing_pipes}</Moment>,
                                                    <Button justIcon round simple onClick={() => this.updateTime("last_flushing_pipes")} color="transparent"><RefreshIcon/></Button>],
                                                ["Дезинфекция", <Moment format="DD/MM/YYYY" locale="ru">{this.state.machineData.last_disinfection}</Moment>,
                                                    <Button justIcon round simple onClick={() => this.updateTime("last_disinfection")} color="transparent"><RefreshIcon/></Button>],
                                                ["Заправка", <Moment format="DD/MM/YYYY" locale="ru">{this.state.machineData.last_refill}</Moment>,
                                                    <Button justIcon round simple onClick={() => this.updateTime("last_refill")} color="transparent"><RefreshIcon/></Button>],
                            ]}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} s={6} md={6}>
                    <Card>
                        <CardHeader color="warning">
                            <h5>Настройки</h5>
                        </CardHeader>
                        <CardBody>
                            <CustomInput
                                labelText="Адрес"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.machineSettings.address,
                                    onChange: e => this._changeValue(e, "address")
                                }}
                            />
                            <CustomInput
                                labelText="Цена за литр"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.machineSettings.liter_for_cash,
                                    onChange: e => this._changeValue(e, "liter_for_cash")
                                }}
                            />
                            <CustomInput
                                labelText="Цена за литр (ключ)"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.machineSettings.liter_for_key,
                                    onChange: e => this._changeValue(e, "liter_for_key")
                                }}
                            />
                            <CustomInput
                                labelText="Импульсов на литр"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.machineSettings.impulse_per_liter,
                                    onChange: e => this._changeValue(e, "impulse_per_liter")
                                }}
                            />
                            <CustomInput
                                labelText="Телефон SIM-модуля"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.machineSettings.sim_module_number,
                                    onChange: e => this._changeValue(e, "sim_module_number")
                                }}
                            />
                            <CustomInput
                                labelText="Телефон администратора"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.machineSettings.admin_phone_number,
                                    onChange: e => this._changeValue(e, "admin_phone_number")
                                }}
                            />
                            <CustomInput
                                labelText="Ключ администратора"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.machineSettings.admin_key_hash,
                                    onChange: e => this._changeValue(e, "admin_key_hash")
                                }}
                            />
                            <CustomInput
                                labelText="Дополнительные параметры"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.machineSettings.additional_params,
                                    onChange: e => this._changeValue(e, "additional_params")
                                }}
                            />
                            <div className={classes.flex_right}>
                                <Button color="primary" onClick={() => this.saveMachine()}>
                                    Сохранить
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
                <SuccessDialog onClose={() => this.successDialogClose()} isOpened={this.state.successDialogIsOpened}/>
                <ErrorDialog onClose={() => this.errorDialogClose()} isOpened={this.state.errorDialogIsOpened}/>
                <LogsDialog onClose={() => this.logsDialogClose()} isOpened={this.state.logsDialogIsOpened}
                            data={this.props.machineLogs.data} limit={this.state.logsLimit}
                            fromTime={this.state.logsFromTime} toTime={this.state.logsToTime}
                            changeFromTime={(time) => this.handleChangeState("logsFromTime", time)}
                            changeToTime={(time) => this.handleChangeState("logsToTime", time)}
                            changeLimit={(limit) => this.handleChangeState("logsLimit", limit)}
                />
                <ConfirmDeleteDialog onCancel={() => this.deleteMachineDialogClose()} onSave={() => this.deleteMachine()}
                                     isOpened={this.state.deleteMachineDialogIsOpened}
                                     bodyText="Вы точно хотите удалить этот автомат? Это действие нельзя будет отменить."/>
                <EditMachineLimitDialog onCancel={() => this.editMachineLimitsDialogClose()} onSave={(machineData) => this.editMachineLimits(machineData)}
                                        isOpened={this.state.editMachineLimitsDialogIsOpened} machineData={this.state.machineData}/>
                <ReactInterval timeout={5 * 60000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </Grid>
        ) :
            (<ReactInterval timeout={5 * 60000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>)
    }
}

MachineView.propTypes = {
    getMachine: PropTypes.func,
    editMachine: PropTypes.func,
    deleteMachine: PropTypes.func,
    getMachineDailySales: PropTypes.func,
    getMachineLogs: PropTypes.func,
    token: PropTypes.string,
    machine: PropTypes.object,
    machineIsLoaded: PropTypes.bool,
    machineLogs: PropTypes.shape({
        data: PropTypes.string,
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
    })
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(machineStyle)(MachineView));


// WEBPACK FOOTER //
// ./src/views/Machines/Machine.jsx